<div class="transcript scrollbar-thin" #messagesContainer>
  <ng-container *ngFor="let msg of messages">
    <div *ngIf="msg.content" class="row" [ngClass]="'role-' + msg.role">
      <ng-container [ngSwitch]="msg.type">
        <app-ai-text-renderer *ngSwitchCase="'text'" [message]="msg"></app-ai-text-renderer>
        <app-ai-copy-suggestions-renderer *ngSwitchCase="'copy-group'" [message]="msg" [addedIds]="addedIds" (action)="emitAction(msg, $event)"></app-ai-copy-suggestions-renderer>
        <app-ai-photo-grid-renderer *ngSwitchCase="'photo-grid'" [message]="msg" [addedIds]="addedIds" (action)="emitAction(msg, $event)" [hidden]="hidePhotoGridRenderer"></app-ai-photo-grid-renderer>
        <div *ngSwitchCase="'error'" class="error-message">
          {{msg.content}}
        </div>

        <!-- Fallback to registry-based dynamic renderers if provided -->
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="getRenderer(msg.type) as cmp; else unknown">
            <ng-container *ngComponentOutlet="cmp; inputs: { message: msg }"></ng-container>
          </ng-container>
          <ng-template #unknown>
            <pre class="unknown">{{ msg.content | json }}</pre>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>
